import { LayoutService } from './../../services/layout.service';
import {Overlay, OverlayOrigin, OverlayConfig} from '@angular/cdk/overlay';
import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnInit,
    ViewEncapsulation,
    ViewChild,
    ViewContainerRef,
    QueryList,
    ViewChildren,
    ElementRef, ComponentRef, Renderer2 } from '@angular/core';
import { MenuService } from '../../services/menu.service';
import { ComponentPortal, Portal, TemplatePortalDirective } from '@angular/cdk/portal';
import { Router } from '@angular/router';
export class MainToolbarComponent implements OnInit {
       notification = false;
       notificationList: Array<any>;
       profile = true;
       showSidenavToggle = true;
       sidenavToggle = new EventEmitter();
       logout = new EventEmitter();
       titleText = 'Humadev Theme';
       titleImg: string;
       theme: 'default' | 'dark' | 'light' = 'dark';
       menu: OverlayOrigin;
       templatePortals: QueryList<Portal<any>>;
      active;
      accountOpen = false;
      notificationOpen = false;
      messageOpen = false;
      topMenuOpen = false;
      brandClass = {
        minimize: false
      };
      brandBackground = '#282a3c';
      brandToggle = {
          'toggler-right': false,
          'toggler-left': true
      };
      sidenav = true;
      progressBar = false;
       minimize = new EventEmitter();
/**
 * @param {?} menuService
 * @param {?} renderer
 * @param {?} elRef
 * @param {?} layout
 * @param {?} router
 */
constructor(
private menuService: MenuService,
private renderer: Renderer2,
private elRef: ElementRef,
private layout: LayoutService,
private router: Router
      ) {
            this.router.events.subscribe(() => this.layout.topProgressBar.next(true));
      }
/**
 * @return {?}
 */
ngOnInit() {
            this.menuService.moduleActive.subscribe(res => {
                  this.active = res;
            });
            if (this.theme === 'dark') {
                this.brandBackground = '#282a3c';
            } else {
                this.brandBackground = '#ffffff';
            }

            this.layout.topProgressBar.subscribe((progress) => this.progressBar = progress);
      }
/**
 * @return {?}
 */
toggleSidenav() {
        if (this.sidenav) {
            this.brandToggle['toggler-right'] = true;
            this.brandToggle['toggler-left'] = false;
        }else {
            this.brandToggle['toggler-right'] = false;
            this.brandToggle['toggler-left'] = true;
        }
        this.sidenav = !this.sidenav;
        this.layout.sidebarOpen.next(this.sidenav);
        this.brandClass.minimize = !this.sidenav;
      }
/**
 * @return {?}
 */
onSidenavToggle() {
            this.sidenavToggle.emit();
      }
/**
 * @return {?}
 */
onLogout() {
            this.logout.emit();
      }
/**
 * @param {?} e
 * @return {?}
 */
onChange(e) {
            this.menuService.navigate(e.value);
      }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'hd-main-toolbar',
    template: `
      <!-- BEGIN: Header -->
      <header>
          <!-- BEGIN: Brand -->
          <div class="toolbar-brand" [ngClass]="brandClass" [ngStyle]="{background: brandBackground}">
              <div class="logo">
                  <a routerLink="">
                      <img [src]="titleImg">
                  </a>
              </div>
              <div class="toggler" *ngIf='showSidenavToggle'>
                  <!-- BEGIN: Left Aside Minimize Toggle -->
                  <a 
                      [ngClass]="brandToggle" 
                      (click)='toggleSidenav()'>
                      <span></span>
                  </a>
                  <!-- END -->
              </div>
          </div>
          <!-- END: Brand -->
          <div class="toolbar-menu">
              <ng-content></ng-content>
          </div>
      </header>
      <mat-progress-bar class="loader" mode="indeterminate" *ngIf='progressBar'></mat-progress-bar>
      <!-- END: Header -->
    `,
    styles: [`
      @media (min-width: 993px) {
        a.toggler-right span {
          background-color: #2739c1 !important; }
        a.toggler-right span:before {
          background-color: #2739c1 !important; }
        a.toggler-right span:after {
          background-color: #2739c1 !important; }
        .toolbar-menu {
          -webkit-box-flex: 1;
              -ms-flex: 1 auto;
                  flex: 1 auto;
          vertical-align: top;
          -webkit-transition: all 0.3s ease;
          transition: all 0.3s ease; } }

      header {
        -webkit-box-shadow: 0 1px 15px 1px rgba(113, 106, 202, 0.1);
        box-shadow: 0 1px 15px 1px rgba(113, 106, 202, 0.1);
        overflow: hidden;
        z-index: 101;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex; }

      .toolbar-brand {
        position: relative;
        vertical-align: middle;
        -webkit-transition: all 0.3s ease;
        transition: all 0.3s ease;
        height: 70px;
        width: 255px;
        table-layout: fixed;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between; }
        .toolbar-brand .logo {
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-flex: 50%;
              -ms-flex: 50%;
                  flex: 50%;
          -webkit-transition: all 0.3s ease;
          transition: all 0.3s ease;
          line-height: 0;
          padding: 15px 20px; }
          .toolbar-brand .logo a img {
            height: 45px; }
        .toolbar-brand .toggler {
          padding: 15px 20px; }
          .toolbar-brand .toggler a {
            line-height: 0;
            vertical-align: middle;
            cursor: pointer;
            display: inline-block;
            position: relative;
            margin: 0;
            padding: 0;
            width: 26px;
            height: 26px;
            font-size: 0;
            text-indent: -9999px;
            -webkit-appearance: none;
            -moz-appearance: none;
            -webkit-box-shadow: none;
                    box-shadow: none;
            border-radius: none;
            border: none;
            background: none;
            outline: none !important;
            -webkit-transition: all 0.4s ease;
            transition: all 0.4s ease; }
            .toolbar-brand .toggler a span {
              background: #5d5f77;
              display: block;
              position: absolute;
              top: 20px;
              height: 1px;
              min-height: 1px;
              width: 100%;
              border-radius: 0px;
              -webkit-transition: all 0.4s ease;
              transition: all 0.4s ease; }
            .toolbar-brand .toggler a span::before {
              top: -7px; }
            .toolbar-brand .toggler a span::after {
              bottom: -7px; }
            .toolbar-brand .toggler a span::before, .toolbar-brand .toggler a span::after {
              background: #5d5f77;
              position: absolute;
              display: block;
              left: 0;
              width: 100%;
              height: 1px;
              min-height: 1px;
              content: "";
              border-radius: 0px;
              -webkit-transition: all 0.4s ease;
              transition: all 0.4s ease; }
          .toolbar-brand .toggler a.toggler-left span::before {
            -webkit-transition: all 0.4s ease;
            transition: all 0.4s ease;
            left: auto;
            right: 0px;
            width: 50%; }
          .toolbar-brand .toggler a.toggler-left span::after {
            -webkit-transition: all 0.4s ease;
            transition: all 0.4s ease;
            left: auto;
            right: 0px;
            width: 75%; }
          .toolbar-brand .toggler a.toggler-right span::before {
            left: 0px;
            right: auto;
            width: 50%;
            -webkit-transition: width 0.4s ease;
            transition: width 0.4s ease; }
          .toolbar-brand .toggler a.toggler-right span::after {
            left: 0px;
            right: auto;
            width: 75%;
            -webkit-transition: width 0.4s ease;
            transition: width 0.4s ease; }
          .toolbar-brand .toggler a:hover span,
          .toolbar-brand .toggler a:hover span::before,
          .toolbar-brand .toggler a:hover span::after {
            width: 100%;
            background: #2a61ac; }

      .toolbar-brand.minimize {
        -webkit-transition: all 0.3s ease;
        transition: all 0.3s ease;
        width: 70px;
        padding-left: 0;
        padding-right: 0; }

      .toolbar-brand.minimize .logo {
        display: none !important; }

      .toolbar-brand.minimize .toggler a {
        text-align: center; }

      .toggler-right:hover span:after,
      .toggler-right:hover span:before {
        width: 100%;
        -webkit-transition: width 0.4s ease;
        transition: width 0.4s ease; }

      .toggler-right.toggler-active span:before {
        left: auto;
        right: 0px;
        width: 50%;
        -webkit-transition: width 0.4s ease;
        transition: width 0.4s ease; }

      .toggler-right.toggler-active span:after {
        left: auto;
        right: 0px;
        width: 75%;
        -webkit-transition: width 0.4s ease;
        transition: width 0.4s ease; }

      .toggler-left:hover span:after,
      .toggler-left:hover span:before {
        width: 100%;
        -webkit-transition: all 0.4s ease;
        transition: all 0.4s ease; }

      .toggler-left.toggler--active span:before {
        -webkit-transition: all 0.4s ease;
        transition: all 0.4s ease;
        left: 0px;
        right: auto;
        width: 50%; }

      .toggler-left.toggler--active span:after {
        -webkit-transition: all 0.4s ease;
        transition: all 0.4s ease;
        left: 0px;
        right: auto;
        width: 75%; }

      header {
        background-color: #ffffff; }

      header .m-header-head {
        background-color: #ffffff; }

      @media (min-width: 993px) {
        header {
          height: 70px; }
        header {
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          z-index: 999;
          position: fixed;
          top: 0;
          left: 0;
          right: 0; }
        .m-header .m-header-head {
          -webkit-transition: all 0.3s ease;
          transition: all 0.3s ease; }
        header .m-header-head {
          -webkit-transition: all 0.3s ease;
          transition: all 0.3s ease;
          padding-left: 300px; }
        header.minimize .m-header-head {
          -webkit-transition: all 0.3s ease;
          transition: all 0.3s ease;
          padding-left: 70px; }
        .m-header--fixed.m-header--fixed-hidable.m-header--hide .m-header {
          height: 70px;
          -webkit-transition: all 0.3s ease 0.5s;
          transition: all 0.3s ease 0.5s;
          -webkit-transform: translateY(-100%);
          transform: translateY(-100%); }
        .m-header--fixed.m-header--fixed-hidable.m-header--show .m-header {
          height: 70px;
          -webkit-transition: all 0.3s ease;
          transition: all 0.3s ease;
          -webkit-transform: translateY(0);
          transform: translateY(0); }
        header .m-header-head {
          -webkit-box-shadow: 0px 1px 15px 1px rgba(113, 106, 202, 0.1);
          box-shadow: 0px 1px 15px 1px rgba(113, 106, 202, 0.1); }
        header {
          -webkit-box-shadow: 0px 1px 15px 1px rgba(113, 106, 202, 0.1);
          box-shadow: 0px 1px 15px 1px rgba(113, 106, 202, 0.1); } }

      @media (max-width: 992px) {
        header {
          height: 60px !important; }
        header .m-header__nav {
          top: -100%;
          position: relative; }
        .m-header--fixed-mobile .m-header {
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          z-index: 101;
          position: fixed;
          top: 0;
          left: 0;
          right: 0; }
        .m-header--fixed-mobile.m-header--fixed-mobile-hidable.m-header--hide .m-header {
          height: 60px;
          -webkit-transition: all 0.3s ease 0.5s;
          transition: all 0.3s ease 0.5s;
          -webkit-transform: translateY(-100%);
          transform: translateY(-100%); }
        .m-header--fixed-mobile.m-header--fixed-mobile-hidable.m-header--show .m-header {
          height: 60px;
          -webkit-transition: all 0.3s ease;
          transition: all 0.3s ease;
          -webkit-transform: translateY(0);
          transform: translateY(0); }
        .m-header--fixed-mobile .m-header .m-header-head {
          -webkit-box-shadow: 0px 1px 15px 1px rgba(113, 106, 202, 0.1);
          box-shadow: 0px 1px 15px 1px rgba(113, 106, 202, 0.1); } }

      .loader {
        z-index: 9999; }

      .mat-progress-bar .mat-progress-bar-element,
      .mat-progress-bar .mat-progress-bar-fill::after {
        height: 3px !important; }
    `],
    encapsulation: ViewEncapsulation.None,
    preserveWhitespaces: false
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MenuService, },
{type: Renderer2, },
{type: ElementRef, },
{type: LayoutService, },
{type: Router, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'notification': [{ type: Input },],
'notificationList': [{ type: Input },],
'profile': [{ type: Input },],
'showSidenavToggle': [{ type: Input },],
'sidenavToggle': [{ type: Output },],
'logout': [{ type: Output },],
'titleText': [{ type: Input },],
'titleImg': [{ type: Input },],
'theme': [{ type: Input },],
'menu': [{ type: ViewChild, args: ['mainMenu', ] },],
'templatePortals': [{ type: ViewChildren, args: [TemplatePortalDirective, ] },],
'minimize': [{ type: Output },],
};
}

function MainToolbarComponent_tsickle_Closure_declarations() {
/** @type {?} */
MainToolbarComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MainToolbarComponent.ctorParameters;
/** @type {?} */
MainToolbarComponent.propDecorators;
/** @type {?} */
MainToolbarComponent.prototype.notification;
/** @type {?} */
MainToolbarComponent.prototype.notificationList;
/** @type {?} */
MainToolbarComponent.prototype.profile;
/** @type {?} */
MainToolbarComponent.prototype.showSidenavToggle;
/** @type {?} */
MainToolbarComponent.prototype.sidenavToggle;
/** @type {?} */
MainToolbarComponent.prototype.logout;
/** @type {?} */
MainToolbarComponent.prototype.titleText;
/** @type {?} */
MainToolbarComponent.prototype.titleImg;
/** @type {?} */
MainToolbarComponent.prototype.theme;
/** @type {?} */
MainToolbarComponent.prototype.menu;
/** @type {?} */
MainToolbarComponent.prototype.templatePortals;
/** @type {?} */
MainToolbarComponent.prototype.active;
/** @type {?} */
MainToolbarComponent.prototype.accountOpen;
/** @type {?} */
MainToolbarComponent.prototype.notificationOpen;
/** @type {?} */
MainToolbarComponent.prototype.messageOpen;
/** @type {?} */
MainToolbarComponent.prototype.topMenuOpen;
/** @type {?} */
MainToolbarComponent.prototype.brandClass;
/** @type {?} */
MainToolbarComponent.prototype.brandBackground;
/** @type {?} */
MainToolbarComponent.prototype.brandToggle;
/** @type {?} */
MainToolbarComponent.prototype.sidenav;
/** @type {?} */
MainToolbarComponent.prototype.progressBar;
/** @type {?} */
MainToolbarComponent.prototype.minimize;
/** @type {?} */
MainToolbarComponent.prototype.menuService;
/** @type {?} */
MainToolbarComponent.prototype.renderer;
/** @type {?} */
MainToolbarComponent.prototype.elRef;
/** @type {?} */
MainToolbarComponent.prototype.layout;
/** @type {?} */
MainToolbarComponent.prototype.router;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
